import NotificationActions from '../../actions/NotificationActions';

import ConfirmPopup from '../common/ConfirmPopup.react';

class Note extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            uuid : uuid(),
            showAdditionalInfo : false,
            confirmClose : false,
        };

        this.close = this.close.bind(this);
    }

    componentDidMount() {
        var self = this;

        if (!this.props.note.sticky)
            setTimeout(() => {
                self.close(false);
            }, this.props.note.timer);
    }

    close(e) {
        var self = this;

        var uuid = this.state.uuid;
        var note = this.props.note;

        if (e && e.target.id === 'i'+this.state.uuid) {
            this.setState({ showAdditionalInfo : true });
            return;
        }

        if (note.additionalInfo && !this.state.confirmClose) {
            this.refs.ConfirmPopup.show();
            return;
        }

        $('#'+uuid+' .note__content').css({
            'left' : '400px',
            'opacity' : 0
        });

        $('#'+uuid).css({
            'height' : parseInt($('#'+uuid).css('height')),
        });

        setTimeout(() => {
            $('#'+uuid).css({
                'height'      : 0,
                'padding-top' : 0
            });

            setTimeout(() => {
                NotificationActions.removeNotification(self.props.note.uuid);
            }, 400);
        }, 400);
    }

    render() {
        var self = this;

        var note = this.props.note;
        var automationId = this.props.automationId || '';

        return ([
            <div
                className='note'
                id={this.state.uuid}
                onClick={e => { this.close(e); }}>

                <div className={'note__content note__content--'+note.type} data-testid={automationId + 'content'}>
                    {note.body}

                    { note.additionalInfo && [
                        <br />,
                        <i className='fa fa-info-circle note__info--icon' id={'i'+this.state.uuid} />
                    ]}
                </div>

            </div>,

            ( this.state.showAdditionalInfo &&
                <div className='smokescreen smokescreen__transparent'>
                    <div className='popup'>

                        <div
                            className='popup__close'
                            onClick={() => { this.setState({ showAdditionalInfo : false }); }}
                            style={{'color':'#ffffff'}}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>

                        <div className='popup__content note__info'>

                            { Object.keys(note.additionalInfo).map(x => {
                                return (
                                    <div key={x}>
                                        <div className='note__info--header'>
                                            {x}
                                        </div>
                                        <div className='note__info--body'>
                                            {note.additionalInfo[x]}
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                </div>
            ),

            <ConfirmPopup
                title='Discard or Show Detailed Info'
                confirmLabel='Discard'
                cancelLabel='Show Info'
                onCancel={() => { this.setState({ showAdditionalInfo : true }); }}
                onConfirm={() => { this.setState({ confirmClose : true }, () => { self.close(false); }); }}
                ref='ConfirmPopup' />
        ]);
    }
}

export default Note;


// WEBPACK FOOTER //
// ./ui_src/app/components/notification/Note.react.jsx